import * as Sentry from "@sentry/react";

import ReloadPrompt from "~/components/ReloadPrompt";
import Config from "~/config";
import AppThemeProvider from "~/providers/AppThemeProvider";
import NetworkStatusProvider from "~/providers/NetworkStatusProvider";
import SnackProvider from "~/providers/SnackProvider";
import Router from "~/router";

if (!Sentry.getClient()) {
	Sentry.init({
		dsn: Config.sentryDSN,
		release: Config.buildVersion,
		environment: Config.environment,
		tracesSampleRate: Config.environment === "production" ? 0.1 : 1.0,
		replaysSessionSampleRate: Config.environment === "production" ? 0.01 : 0.1,
		replaysOnErrorSampleRate: 1,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
	});
}

/**
 * App shell: theme + snackbar + network-status providers wrapping the router, plus the service
 * worker update prompt. The Redux `<Provider>` and `PersistGate` are mounted one level up in
 * `main.tsx`, so NetworkStatusProvider (which dispatches the SW offline-queue events into Redux)
 * sits inside them. Feature pages render through the mobile shell in the router.
 */
const App = () => (
	<AppThemeProvider>
		<SnackProvider>
			<NetworkStatusProvider>
				<Router />
				<ReloadPrompt />
			</NetworkStatusProvider>
		</SnackProvider>
	</AppThemeProvider>
);

export default App;
